import { forwardRef } from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

// Custom styles for MDSelect
import MDSelectRoot from "components/MDSelect/MDSelectRoot";

const MDSelect = forwardRef(
  ({ error, success, disabled, label, value, onChange, options, ...rest }, ref) => (
    <FormControl fullWidth variant="outlined" disabled={disabled} error={error} success={success}>
      <InputLabel id={`${label}-label`}>{label}</InputLabel>
      <MDSelectRoot
        {...rest}
        labelId={`${label}-label`}
        label={label}
        value={value}
        onChange={onChange}
        sx={{ height: "43px" }}
        ownerState={{ error, success, disabled }}
        ref={ref}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MDSelectRoot>
    </FormControl>
  )
);

// Setting default values for the props of MDSelect
MDSelect.defaultProps = {
  error: false,
  success: false,
  disabled: false,
  label: "",
  value: "",
  options: [],
};

// Typechecking props for the MDSelect
MDSelect.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default MDSelect;
